export default "__VITE_ASSET__31a1e373__"